import React, { FC } from "react";

export const AddIcon: FC<any> = (props) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill={props.color || 'none'}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 10H15"
                stroke={props.color || "#7489AA"}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 15V5"
                stroke={props.color || "#7489AA"}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
